export default __webpack_public_path__ + "static/media/suitcases.32f421f5.svg";